export default __webpack_public_path__ + "static/media/22.0e21fa25.jpg";